const haematuria = [

{label:"Pain:",
controlType:"radio button",
options:["Painful", "Painless"]
}, 

{label:"Blood clots:",
controlType:"radio button",
options:["Blood clots", "No blood clots"]
}, 
    
{label:"Frequency",
controlType:"radio button",
options:["Every day", "Most days", "Evey week or two", "Occasionally"]
},

{label:"Present for several:",
controlType:"radio button",
options:["Days", "Weeks","Months","Years"]
}

]

export default haematuria